import React from 'react';
import {
 LucideIcon
} from 'lucide-react';
import {
 Badge
} from 'shared/components/ui/badge';

interface PlaceholderPageProps {
    title: string;
    icon: LucideIcon;
    description?: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
 title, icon: Icon, description
}) => {
    return (
        <div className="flex flex-1 flex-col items-center justify-center min-h-[60vh] gap-4">
            <div className="rounded-full bg-muted p-6">
                <Icon className="h-12 w-12 text-muted-foreground" />
            </div>
            <h2 className="text-2xl font-semibold">{title}</h2>
            <Badge variant="secondary" className="">Coming Soon</Badge>
            {description && (
                <p className="text-muted-foreground text-center max-w-md">{description}</p>
            )}
        </div>
    );
};

export default PlaceholderPage;
